import { connect } from 'react-redux'

import { RootState } from '../../../store'
import ManageAgencyDetail from '../../../components/pages/ManageAgency/ManageAgencyDetail'

/**
 * Import
 * - Actions
 */
import {
    fetchAgencySummary,
    fecthTrackerActivityTypes,
    getUserDetail,
    fetchUsers,
    deactivateUser,
    fecthPoliciesList,
    fecthAgencyRenewalsList,
    fecthLapseRenewal,
    fecthRenewAsIs,
    changeUserTypeAgency,
} from '../../../actions'

const mapStateToProps = (state: RootState) => {
    return {
        agencySummary: state.agencySummary,
        activityTracker: state.activityTracker,
        userDetail: state.users.userInformation,
        sessionUser: state.userDetail,
        usersList: state.users.users,
        deactivateUser: state.users.deactivateUser,
        clientList: state.clientList,
        renewals: state.renewals.renewals,
        renewAsIs: state.renewals.renewAsIs,
        changeUserType: state.users.userType,
    }
}

export default connect(mapStateToProps, {
    fetchAgencySummary: fetchAgencySummary,
    fecthTrackerActivityTypes: fecthTrackerActivityTypes,
    getUserDetail: getUserDetail,
    fecthPoliciesList: fecthPoliciesList,
    fetchUsers: fetchUsers,
    fetchDeactivateUser: deactivateUser,
    fecthRenewalsList: fecthAgencyRenewalsList,
    fecthLapseRenewal,
    fecthRenewAsIs,
    changeUserTypeAgency,
})(ManageAgencyDetail)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/ManageAgency/ManageAgencyDetail.tsx